import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { user } from '../util/api'
import LoadingSpinner from './../routes/components/LoadingSpinner'

export const AuthContext = React.createContext()

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  let location = useLocation()

  function logout() {
    setUser(null)
    localStorage.removeItem('AccessToken')
    localStorage.removeItem('IsAuth')
    navigate('/sign-in')
  }

  function resetPassword() {}

  const isAuth = async () => {
    return await localStorage.getItem('IsAuth')
  }

  useEffect(() => {
    // const authRequired = ['/city', '/passage', '/idea']
    // console.log(authRequired.find((element) => element === location.pathname))

    // if (authRequired.find((element) => element == location.pathname) !== undefined) {
    //   navigate('/login')
    // }
    isAuth().then((res) => {
      setUser(res)
      setLoading(false)
    })
  }, [user])

  const value = {
    user,
    setUser,
    logout,
    resetPassword,
  }

  if (loading)
    return (
      <h1>
        <LoadingSpinner /> Loading in Auth Context...
      </h1>
    )
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
